import { render, staticRenderFns } from "./GerenciarUnidadesPrimarias.vue?vue&type=template&id=2baf8289&scoped=true"
import script from "./script.js?vue&type=script&lang=js&external"
export * from "./script.js?vue&type=script&lang=js&external"
import style0 from "./GerenciarUnidadesPrimarias.vue?vue&type=style&index=0&id=2baf8289&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2baf8289",
  null
  
)

export default component.exports